import React from 'react';
import cx from 'classnames';
import {$getSelection, $isRangeSelection, LexicalEditor} from 'lexical';
import {useCallback} from 'react';
import {$patchStyleText} from '@lexical/selection';
import DropDown, {DropDownItem} from '../../../ui/DropDown/DropDown';
import {FontDropDownMode} from './enums';

type Props = {
    editor: LexicalEditor;
    value: string;
    mode: FontDropDownMode;
    disabled?: boolean;
    options: [string, string][];
    label: string;
};

export function FontDropDown(props: Props) {
    const {editor, value, mode, options, disabled = false, label} = props;

    const handleClick = useCallback(
        (option: string) => {
            editor?.update(() => {
                const selection = $getSelection();
                if ($isRangeSelection(selection)) {
                    $patchStyleText(selection, {[mode]: option});
                }
            });
        },
        [editor, mode]
    );

    const buttonAriaLabel =
        mode === 'font-family'
            ? 'Formatting options for font family'
            : 'Formatting options for font size';

    return (
        <DropDown
            disabled={disabled}
            buttonClassName={cx('priority-editor__toolbar-item ', mode)}
            buttonLabel={label}
            buttonAriaLabel={buttonAriaLabel}
        >
            {options.map(([option, text]) => (
                <DropDownItem
                    className={cx('item', {
                        'active dropdown-item-active': value === option,
                        'fontsize-item': mode === 'font-size'
                    })}
                    onClick={() => handleClick(option)}
                    key={option}
                >
                    <span className="text">{text}</span>
                </DropDownItem>
            ))}
        </DropDown>
    );
}
